import { useContext } from "react";
import AuthContext from "../../contexts/AuthContext";

const useIsFeatureEnabled = featureName => {
  const { features } = useContext(AuthContext).state;
  return !!features && !!features[featureName];
};

export default useIsFeatureEnabled;
